import { render, staticRenderFns } from "./IconPackSelector.vue?vue&type=template&id=5a7a1e43"
import script from "./IconPackSelector.vue?vue&type=script&lang=js"
export * from "./IconPackSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports